/* global axios */
import ApiClient from '../ApiClient';

class InboxKanbanAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  board(inboxId) {
    return axios.get(`${this.url}/${inboxId}/kanban/board`);
  }

  columns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/kanban/columns`);
  }

  createColumn(inboxId, payload) {
    return axios.post(`${this.url}/${inboxId}/kanban/columns`, payload);
  }

  updateColumn(inboxId, columnId, payload) {
    return axios.patch(`${this.url}/${inboxId}/kanban/columns/${columnId}`, payload);
  }

  deleteColumn(inboxId, columnId) {
    return axios.delete(`${this.url}/${inboxId}/kanban/columns/${columnId}`);
  }

  moveConversation(conversationId, payload) {
    return axios.patch(`${this.baseUrl()}/conversations/${conversationId}/kanban/move`, payload);
  }
}

export default new InboxKanbanAPI();
